module.exports = __webpack_public_path__ + "static/media/Question-check.d6b31b97.png";